export default __webpack_public_path__ + "static/media/groupcall1.449a21cc.svg";